"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTypeEnum = void 0;
var FormTypeEnum;
(function (FormTypeEnum) {
    FormTypeEnum["Contact"] = "Contact";
    FormTypeEnum["Conversation"] = "Conversation";
    FormTypeEnum["Website"] = "Website";
})(FormTypeEnum = exports.FormTypeEnum || (exports.FormTypeEnum = {}));
